import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import { compose } from "redux";
import styled from "styled-components";
import { connect } from "react-redux";

import { setA11yContent } from "../../NavigationHelper/actions";
import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import AEMContentFromHTML from "../../../../hoc/AEMContentFromHTML";
import DeleteReview from "./DeleteReview";
import Modal from "common-components/Modal/Modal";

class DeleteInformationMember extends Component {
  state = {
    loading: true,
    pageContent: {},
    visibleModal: false
  };
  handleModalPopup = () => {
    this.setState({ visibleModal: false });
  };

  componentDidMount() {
    if (checkNestedObject(this.props, "pageContent", "sections")) {
      this.setState(
        {
          pageContent: { ...this.props.pageContent.sections[1][8] },
          memberModalContent: { ...this.props.pageContent.sections[1][9] },
          loading: false
        },
        () => {
          this.props.setA11yContent(
            "Delete information Member",
            this.state.pageContent.sc_pagetitle
          );
        }
      );
    }
  }

  handleContinueClick = () => {
    return (window.location.href = window.reactGlobals.guestDeleteCTAUrl);
  };

  renderContinueButton = ({ text, type }) => {
    return (
      <Button background={type} onClick={() => this.setState({ visibleModal: true })}>
        {text}
      </Button>
    );
  };

  render() {
    if (this.state.loading) {
      return <RectangleLoader />;
    }

    const { pageContent, memberModalContent } = this.state;

    return (
      <Container noTabletPadding>
        <div style={{ maxWidth: "596px" }}>
          <Header>{pageContent.section_title}</Header>
          <HeaderDesc>{convertStringToElements(pageContent.section_description)}</HeaderDesc>
          {pageContent.icontexts.map(item => (
            <Div key={item.text}>
              {convertStringToElements(item.icon)}
              {convertStringToElements(item.text)}
            </Div>
          ))}
        </div>
        <ButtonContainer>
          {this.renderContinueButton(pageContent.buttons[0])}
          <Button
            role="link"
            background={pageContent.buttons[1].type}
            onClick={() => this.props.history.goBack()}
          >
            {pageContent.buttons[1].text}
          </Button>
        </ButtonContainer>

        <Modal id="modalStyle" visibleModal={this.state.visibleModal} closeModal={this.handleModalPopup}>
          <DeleteReview
            closeModal={this.handleModalPopup}
            member={true}
            handleContinueClick={this.handleContinueClick}
            memberModalContent={memberModalContent}
          />
        </Modal>
      </Container>
    );
  }
}

export default compose(
  connect(
    null,
    { setA11yContent }
  ),
  AEMContentFromHTML
)(DeleteInformationMember);

DeleteInformationMember.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

const Container = styled(CommonContainer)`
  padding-top: 80px;

  ${media.tablet`
    max-width: 80%;
  `}

  ${media.mobile`
    padding-top: 20px;
  `}
`;

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }

  p strong {
    font-size: 20px;
    line-height: 19px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }

  ul {
    list-style: disc inside;
    margin: 15px 0;
  }
`;

const HeaderDesc = styled.p`
  font-size: 20px;
  line-height: 24px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;

  ${media.mobile`
    font-size: 16px;
    line-height: 20px;
  `}
`;

const ButtonContainer = styled.div`
  margin-top: 56px;
  button,
  a {
    width: 172px;
  }
`;
